// src/data/reviews.js
export const reviews = [
  {
    id: 1,
    name: "Destiny Gillespie",
    date: "a month ago",
    rating: 5,
    text: "After reading all the great reviews and searching for a place that can help me on my healthy curl journey, I decided to give this place a try. I’m so happy that I did because Mina is so amazing and sweet! She took the time to hear all the details about my hair’s history and the direction I wanted to take it in. She made me feel so comfortable throughout this whole process and took the time to give me tips and advice for my curls. I can tell how much effort and passion she puts into doing these services and I truly admire her! I will definitely be coming back and I 100% recommend this salon to everyone!!! Thanks again Mina!",
    avatar: "D"
  },
  {
    id: 2,
    name: "Amanda Romano",
    date: "a week ago",
    rating: 5,
    text: "Samina is amazing! I've been to her twice for curly cut and again for a trim. She is patient, listens to exactly what you're looking for and educates on how to care for your curls. Samina also did a full head of highlights for me. I've been doing highlights for over a decade and this is the best color I've ever had. I would recommend Samina 10/10.",
    avatar: "A"
  },
  {
    id: 3,
    name: "Vibha Patel Mahadeo",
    date: "a week ago",
    rating: 5,
    text: "Mina really took care of my wavy/curly hair. She listened to what I had to say and then talked me through what she was doing after the cut so that I could learn how to care for my hair. I'll be back for another cut soon!",
    avatar: "V"
  },
  {
    id: 4,
    name: "anjali verma",
    date: "2 weeks ago",
    rating: 5,
    text: "Samina always does an amazing job!! She's the first hair stylist I've ever had that actually listens to me and gave me the cut I wanted for my curls",
    avatar: "A"
  },
  {
    id: 5,
    name: "Mia Fernandez",
    date: "2 weeks ago",
    rating: 5,
    text: "I can't recommend Samina enough! My curl journey has been anything but easy, but Samina turned it all around. She really knows her stuff when it comes to curls. She taught me how to properly treat my curls and the best way to diffuse them. Thanks to her, my curls have never looked better. Samina took the time to understand my hair type and gave me personalized tips that actually work. Her expertise and patience have made such a difference. If you're struggling with your curls, this salon is the one you need!",
    avatar: "M"
  },
  {
    id: 6,
    name: "Nora Zohrabian",
    date: "2 weeks ago",
    rating: 5,
    text: "Samina was able to take me in on short notice via an online booking which is super convenient. She has expertise in styling and cutting curly hair and took the time to explain and spot out solutions to the issues of my hair and it was a customized experience from start to finish. My hair was much healthier and felt naturally treated after I left . She talks to you throughout the process, explaining each step. Her assistant was very warm and friendly as well. Not a pretentious place , easy to talk to , not overwhelming. It is situated on main street and yet felt nestled . Great location and also very clean inside . Thank you and God bless!",
    avatar: "N"
  },
  {
    id: 7,
    name: "C Rhodes",
    date: "2 weeks ago",
    rating: 5,
    text: "As someone who has never had a curly cut before, I will say Samina was the perfect person for the job. Not only did Samina listen to my desires before doing any cutting or styling, she coached me on how to care for my curls throughout the process. I now know how to get the best out of my 3b/3c low porosity hair. Thank you !",
    avatar: "C"
  },
  {
    id: 8,
    name: "Ashley Mathew",
    date: "a month ago",
    rating: 5,
    text: "Got the best cut and blow out from Samina! She's the best and she knows exactly what suits your hair. She'll never disappoint.",
    avatar: "A"
  },
  {
    id: 9,
    name: "Alana H.",
    date: "a month ago",
    rating: 5,
    text: "You get what you pay for. I came in for a dry curly cut, which starts at $135+ as listed on the website but my cut wound up being $175 because I have very thick and very long hair. Mina took time and care to make sure I was comfortable, understood the scope of the pricing for my personal cut, and took the time to understand the look I was trying to achieve. She definitely understands curly hair and I would highly recommend for anyone looking for a quality stylist on Long Island!",
    avatar: "A"
  },
  {
    id: 10,
    name: "Sarah M.",
    date: "4 months ago",
    rating: 5,
    text: "Always get good service and haircuts here. The only problem I have is that there's no Nassau County location, and I have to drive 40 minutes out. Worth it though!",
    avatar: "S"
  },
  {
    id: 11,
    name: "Maura D.",
    date: "3 years ago",
    rating: 4,
    text: "Clean salon, super friendly staff and wonderful owner. My experience was great except for the fact that this place is not very curly friendly. Despite its name there is no specific curly haircut or curly care option",
    avatar: "M"
  },
  {
    id: 12,
    name: "Asha Jacob",
    date: "a month ago",
    rating: 5,
    text: "Had my first dry cut and it did not disappoint!! It's hard to find someone who understands curls, but Samina was knowledgeable, caring, and lovely. She transformed my hair and I'm so excited to tell my curly haired friends about her, especially since the salon is so close to where many of them live!",
    avatar: "A"
  },
  {
    id: 13,
    name: "Michelle Ferro",
    date: "a month ago",
    rating: 5,
    text: "Thank you Samina!!  If you want to love your curly hair Cut N Curls is a must.  I was nervous and stressed. Samina was kind and gentle with me. She did not push anything I was not comfortable with.  I told her I have had bad haircuts in the past and was stressed....my last cut was 2 years ago.  I left feeling lighter and my hair looks gorgeous!!!  My curls are soft and bouncy. She gave me some tips and encouraged my return for healthy hair. I will absolutely be returning.  She was honest as well. Letting me know the cost of the service prior to starting😀",
    avatar: "M"
  },
];